const api_url = {
  API: process.env.REACT_APP_API_URL + 'talousmobiili/',
  PWRESET: process.env.REACT_APP_PWRESET ? process.env.REACT_APP_PWRESET : null
};

export default api_url;
